<template>
  <li class="my-2 text-base md:text-sm flex items-center pr-10">
    <span v-if="tagSaved" class="mr-2">
      <FaIcon :icon="['fas', 'check']" class="fa-xs" />
    </span>

    <span class="tag grow">
      {{ tag }}
    </span>

    <button @click.prevent="handleRemove" class="text-red-600 focus:outline-hidden">
      <FaIcon :icon="['far', 'trash']" class="fa-xs" title="Delete result" />
    </button>
  </li>
</template>

<script>
export default {
  props: {
    results: {
      type: Array,
      default: () => [],
    },
    tag: {
      type: String,
      required: true,
    },
  },
  computed: {
    tagSaved() {
      return this.results.includes(this.tag)
    },
  },
  methods: {
    handleRemove() {
      this.$emit("remove", this.tag)
    },
  },
}
</script>
